//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { Switch } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import pluralize from "pluralize";
import React from "react";
import { IOldAdditionalInfo, IOldRequestStore } from "../stores";
import EditableInput from "./EditableInput";
import TutorMatchedSubject from "./TutorMatchedSubject";

const TutorRequestPool: React.FC<{
  store: IOldRequestStore;
  [key: string]: any;
}> = ({
  loading,
  typing,
  component,
  poolId,
  showDetail,
  key,
  tutorName,
  tutorEmail,
  tutorPhoneNo,
  tutorAddress,
  cost,
  defaultSubject,
  matchedSubjects,
  approved,
  teachesAll,
  updateMsg,
  store,
  toggleUpdateBtn,
  toggleTutorDetail,
  handleUpdateTutorPrice,
  handleChangeDefaultSubject,
  handleToggleTutorApproval,
}) => {
  let pool = store.requestPool.find((o) => o.pool_id === poolId);
  return (
    <div className="tutor-pool-item col-12">
      <div className="row" style={{ marginBottom: "10px" }}>
        <div className="col-sm-3 pd-left--0 pd-right--0">
          <div>
            <strong
              title="toggle between tutor's details and his/her subjects"
              onClick={toggleTutorDetail}
            >
              {tutorName}
            </strong>
            {teachesAll === true ? (
              <i
                title="this tutor has indicated he/she can teach all the clients's requested subjects"
                className="fa fa-check teaches-all--check"
                aria-hidden="true"
              />
            ) : null}
            :
            <Switch
              size="sm"
              style={{ verticalAlign: "middle" }}
              title="toggle between all tutor's details and their subjects"
              isChecked={showDetail}
              onChange={toggleTutorDetail}
            />
          </div>
          {loading === true ? <div className="loader" /> : null}
          <button
            title="change the tutor's approve status to either true or false"
            type="button"
            className={`btn btn-secondary btn-sm btn-approve--request ft-14 ${
              approved === true ? "btn-danger" : null
            }`}
            onClick={() => handleToggleTutorApproval(!approved)}
          >
            {approved === true ? "Disapprove" : "Approve"}
          </button>
        </div>
        {showDetail ? (
          <React.Fragment>
            <div className="col-sm-5 pd-right--0">
              <div className="request-subject">
                <p>{tutorEmail}</p>
                <p>{tutorPhoneNo}</p>
              </div>
            </div>
            <div className="col-sm-4 pd-right--0">
              <div className="request-subject">
                <p>{tutorAddress}</p>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="col-sm-3 pd-right--0">
              {matchedSubjects.length > 0 ? (
                matchedSubjects.map((subject, index) => (
                  <TutorMatchedSubject
                    toggleUpdateBtn={toggleUpdateBtn}
                    key={index}
                    subject={subject}
                  />
                ))
              ) : (
                <p>No matched subjects</p>
              )}
            </div>
            <React.Fragment>
              <EditableInput
                asForm={false}
                keyText={`info`}
                className="col-sm-6"
                containerClass="col-sm-3 pd-right--0"
                contentClass="col-sm-9 text-right pd-right--0 "
                buttonStyles={{
                  colorScheme: "orange",
                  className: `ft-14 btn btn-warning`,
                }}
                onSubmit={(event, result) => {
                  event.preventDefault();
                  event.stopPropagation();
                  console.log(result);
                  return store.updateAdditionalInfo(poolId, component, result);
                  // split.updateSplitInfo(result);
                }}
                data={[
                  {
                    defaultValue: pool?.additionalInfo?.budget,
                    name: "tutor-budget",
                    key: `budget`,
                    labelText: "Budget",
                  },
                  {
                    defaultValue: pool?.additionalInfo?.no_of_lessons,
                    name: "lessons",
                    key: "no_of_lessons",
                    labelText: "No of Lessons",
                    suffix: pluralize(
                      "lesson",
                      pool?.additionalInfo.no_of_lessons,
                      false,
                    ),
                    width: "20%",
                  },
                ]}
                title="update this tutor's price"
              >
                <EditableInput
                  className="col-sm-12"
                  onSubmit={handleUpdateTutorPrice}
                  defaultValue={cost}
                  buttonStyles={{
                    colorScheme: "green",
                    className: `ft-14 btn btn-success`,
                  }}
                  name="price"
                  asForm
                  type="number"
                  text="/hr"
                  title="update this tutor's price"
                >
                  <select
                    className="select-subject"
                    name="defaultSubject"
                    onChange={handleChangeDefaultSubject}
                    title="change the tutor's default subject for this request"
                  >
                    <option value="">select default</option>
                    {matchedSubjects.map((subject, index) => (
                      <option
                        value={subject.name}
                        key={"subject " + index}
                        selected={subject.name === defaultSubject}
                      >
                        {subject.name}
                      </option>
                    ))}
                  </select>
                </EditableInput>
              </EditableInput>
            </React.Fragment>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default observer(TutorRequestPool);
